<template>
	<div class="position-absolute">
		<!-- 저장 -->
		<sf-button v-if="isButton_(scrId, 'CC')" line icon="file" :onClick="saveAction">
			{{ getMessage_('QWCC001131') }}
		</sf-button>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		addRow() {
			this.setRowInit_();
		},
		saveAction() {
			try {
				if (!this.searchParams.custCd || !this.searchParams.cpnyScn) {
					//저장할 업체 정보가 없습니다. 먼저 업체를 검색해주세요.
					throw new Error(this.getMessage_('QWCC001356'));
				}
				// if (!this.detailList.length) {
				// 	//선택된 정보가 없습니다.
				// 	throw new Error(this.getMessage_('QWCC001556'));
				// }
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					message: this.getMessage_('QWCC001119'),
					buttons: [{ title: 'Ok', clickFn: this.save }]
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			}
		},
		async save() {
			try {
				this.$sf_toggleLoading(true);
				const {
					header: { code, messageCd }
				} = await this.saveData_();
				if (code === 0 || code === 3) {
					this.$sf_toast({
						type: code === 0 ? 'ok' : 'error',
						message: this.getMessage_(messageCd)
					});
				}
				code === 0 && this.refresh();
			} catch (error) {
				this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001402') }); //저장에 실패
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		uploadExcel() {},

		/** 저장 후 새로고침 */
		async refresh() {
			this.isLoaded = false;
			this.$sf_toggleLoading(true);
			try {
				this.addRow();
				await this.getList_();
				this.searchParams.custCd && (await this.getDetailList_());
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			} finally {
				this.$sf_toggleLoading(false);
				this.isLoaded = true;
			}
		}
	}
};
</script>

<style lang="scss" scoped></style>
